// extracted by mini-css-extract-plugin
export default {"container":"banner_container__FkwtK","container_icon":"banner_container_icon__jNajO","container_text":"banner_container_text__SBYJy"};